import React from "react";

function ComplainShortcutTable({ data }) {
  return (
    <div className="w-full custom-shadow rounded-[32px] overflow-hidden mt-4">
      {/* <div className="bg-btn-secondary w-full">
        <p className="text-[18px] py-[13px] text-txt-secondary text-center ">
          {title}
        </p>
      </div> */}
      <div>
        <table className="table-fixed w-full">
          <thead className="py-4 border-0">
            <tr className='bg-btn-secondary'>
              <th className="text-[18px] text-txt-secondary py-4">Property</th>
              <th className="text-[18px] text-txt-secondary py-4">Customer</th>
              <th className="text-[18px] text-txt-secondary py-4">Date & Time</th>
              <th className="text-[18px] text-txt-secondary py-4">Complain Details</th>
              <th className="text-[18px] text-txt-secondary py-4">Booking Details</th>
              <th className="text-[18px] text-txt-secondary py-4">Status</th>
            </tr>
          </thead>
          <tbody className=''>
            {data &&
              data.map((item, index) => {
                return (
                  <tr key={index} className='border-b last:border-0 border-btn-border'>
                    <td className="text-[12px] py-4 text-center">{item.property}</td>
                    <td className="text-[12px] py-4 text-center">{item.customer}</td>
                    <td className="text-[12px] py-4 text-center">{item.dateTime}</td>
                    <td className="text-[12px] py-4 text-center">{item.complainDetails}</td>
                    <td className="text-[12px] py-4 text-center">{item.bookingDetails}</td>
                    <td className="text-[12px] py-4 text-center">{'New'}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ComplainShortcutTable;
